import React from 'react';
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from '@/components/shadcn/accordion';
import { H5 } from '@/components/shadcn/typography';
import Markdown from './Markdown';

export interface FAQItem {
  question: string;
  answer: string;
}

interface FAQsProps {
  items: FAQItem[];
}

export const FAQItem = ({ question, answer }: FAQItem) => {
  return (
    <Accordion className="w-full" key={question} type="single" collapsible>
      <AccordionItem
        className="rounded-lg border border-neutral-800 bg-neutral-900 last:border-b"
        value={question}>
        <AccordionTrigger className="items-center">
          <H5 className="text-left font-lato text-sm font-normal lg:text-lg">
            {question}
          </H5>
        </AccordionTrigger>
        <AccordionContent className="pb-6">
          <Markdown className="!text-base font-light">{answer}</Markdown>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

const FAQs = ({ items }: FAQsProps) => {
  return (
    <div className="flex w-full flex-col gap-4">
      <ul className="mx-auto flex w-full max-w-[1000px] flex-col gap-4">
        {items.map((item, index) => (
          <li key={index}>
            <FAQItem question={item.question} answer={item.answer} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FAQs;
